<template>
  <div>
    <input type="file" @change="handleFileChange" />
    <b-button @click="handleProcessClick">
      Process
    </b-button>
    <h5 v-if="objs && Array.isArray(objs)">
      {{ objs.length }} items to process
    </h5>
  </div>
</template>

<script>
import XLSX from "xlsx";
//https://www.npmjs.com/package/xlsx-style-cptable //TODO- Enhance
export default {
  props: {
    columns: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    columnsAssoc() {
      return this.convertColumnToAssocObj();
    }
  },
  data() {
    return {
      objs: [],
      headerColumnDiff: null
    };
  },
  components: {},
  mixins: [],
  mounted() {},
  methods: {
    handleFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.convertToJSONHeaderRows(files[0]);
    },
    convertToJSON(file) {
      /* Boilerplate to set up FileReader */
      const reader = new FileReader();
      reader.onload = e => {
        var data = e.target.result;
        var workbook = XLSX.read(data, { type: "binary" });
        let sheetName = workbook.SheetNames[0];
        let worksheet = workbook.Sheets[sheetName];
        let rowObject = XLSX.utils.sheet_to_row_object_array(worksheet);
        const finalJsonData = JSON.stringify(rowObject, undefined, 4);
        console.log(finalJsonData);
        this.$emit(`spreadsheet-json`, finalJsonData);
      };
      reader.readAsBinaryString(file);
    },
    convertToJSONHeaderRows(file) {
      /* Boilerplate to set up FileReader */
      const reader = new FileReader();
      reader.onload = e => {
        /* Parse data */
        const bstr = e.target.result;
        const wb = XLSX.read(bstr, { type: "binary" });
        /* Get first worksheet */
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        /* Convert array of arrays */
        const rows = XLSX.utils.sheet_to_json(ws, { header: 1 });
        /* Update state */
        //add daata and send
        const header = rows.shift();

        const objects = this.buildObjects(header, rows);
        // this.$emit(`spreadsheet-json`, header, objects);
      };
      reader.readAsBinaryString(file);
    },
    buildObjects: function(header, rows) {
      if (this.verifyHeaderColumnsKeys(header)) {
        rows.forEach(aRow => {
          const anObject = {};

          header.forEach((columnName, index) => {
            console.log(index);
            if (columnName) {
              const key = this.columnsAssoc[columnName];
              if (key) anObject[key] = aRow[index];
            }
          });
          if (
            !Object.values(anObject).every(
              x => x === null || x === "" || x === undefined
            )
          ) {
            //verify not empty
            this.objs.push(anObject);
          }
        });
      }
    },
    verifyHeaderColumnsKeys(header) {
      return true;
      if (
        !Array.isArray(header) ||
        !Array.isArray(this.columns) ||
        header.length !== this.columns.length
      ) {
        const columnKeys = Object.keys(this.columnsAssoc);
        this.headerColumnDiff = columnKeys.filter(x => !header.includes(x));

        console.log("Headers do not match");
        return false;
      }
      //Now compare each column
      return true;
    },
    convertColumnToAssocObj() {
      return this.columns.reduce((result, { label, value }) => {
        result[label] = value.replace(/\s/g, "");
        return result;
      }, {});
    },
    handleProcessClick() {
      this.$emit("process-items", this.objs);
    }
  }
};
</script>

<style lang="scss" scoped></style>
